import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.8236 2.33484C10.3681 1.88839 9.62827 1.88839 9.17272 2.33484L3.34166 8.04944C2.88611 8.4959 2.88611 9.22094 3.34166 9.66739C3.79721 10.1138 4.53703 10.1138 4.99258 9.66739L8.83379 5.89932V16.8571C8.83379 17.4893 9.35494 18 10 18C10.6451 18 11.1662 17.4893 11.1662 16.8571V5.89932L15.0074 9.66382C15.463 10.1103 16.2028 10.1103 16.6583 9.66382C17.1139 9.21737 17.1139 8.49233 16.6583 8.04587L10.8273 2.33127L10.8236 2.33484Z",
		fill: "#0D2976"
	})
});
export default SvgArrowUp;
